import _defineProperty from "@babel/runtime/helpers/defineProperty";

var _desktop, _mobile;

import { EEstimationTargets } from '../../../../../types';
export var placeholders = {
  desktop: (_desktop = {}, _defineProperty(_desktop, EEstimationTargets.flat, 'Населенный пункт, улица, дом *'), _defineProperty(_desktop, EEstimationTargets.newbuilding, 'Адрес или название ЖК *'), _desktop),
  mobile: (_mobile = {}, _defineProperty(_mobile, EEstimationTargets.flat, 'Населенный пункт, улица, дом'), _defineProperty(_mobile, EEstimationTargets.newbuilding, 'ЖК Скандинавский луг'), _mobile)
};